<template>
  <ColumnBarChartTemplate
    :chartMainData="spk2ProjectsDistributionPerMonth"
    :chartOptionsFuncParams="chartOptionsFuncParams"
    :year-start="2017"
    chartSeriesYKey="totalUsers"
    projectsByMonth
    chartTitle="Выберите проект, чтобы увидеть аналитику регистраций по месяцам"
    @year-update="yearUpdate"
    @project-update="projectUpdate"  
  />
</template>
<script>
import ColumnBarChartTemplate from "./templates/ColumnBarChartTemplate.vue";
import { graphQueryConstructor } from "@/tools/graphQueryConstructor";
import { gQueryOptionsTemplate } from './chartHelper';
import gql from 'graphql-tag';
import { mapGetters } from 'vuex';

export default {
  name: "ProjectDistributionByMonthChart",
  components: {
    ColumnBarChartTemplate,
  },
  props: {
    apolloSearchString: {
      type: String,
      default: "",
    },
    userSearchFilters: {
      type: Object,
    },
    selectedTags: {
      type: Array,
      default: () => [],
    },
  },
  apollo: {
    spk2ProjectsDistributionPerMonth: {
      query() {
        return gql(graphQueryConstructor(
          ...gQueryOptionsTemplate(
              this.hasUserContactsAccess,
              this.apolloSearchString,
              this.userSearchFilters,
              this.selectedTags,
              "spk2ProjectsDistributionPerMonth",
              this.year,
              this.projectId,
            )
        ));
      },
    },
  },
  data() {
    return {
      year: new Date().getFullYear(),
      projectId: "f209fe07-0ec8-4bd2-a4df-f78e15df7da0", // проект пустышка
      chartOptionsFuncParams: {
        title: {
          word: "Участни",
          e1: "к",
          e2: "ка",
          e3: "ков",
        },
      },
    };
  },
  methods: {
    yearUpdate(value) {
      this.year = value;
    },
    projectUpdate(value) {
      this.projectId = value;
    },
  },
  computed: {
    ...mapGetters('auth', ['hasUserContactsAccess']),
  },
}; 
</script>
<style>
</style>